export const conversation = (state) => {
    return state.conversation;
}